import { Button, SIZE_BLOCK, STYLE_FILL } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import ButtonFromGoogle from '@google-pay/button-react';
import { GooglePayment } from 'braintree-web';
import React, { useEffect } from 'react';
import './GooglePayButton.scss';

interface GooglePayButtonProps {
    clearError: () => void;
    defaultLocale: string;
    environment: 'TEST' | 'PRODUCTION';
    handleOnCancel: () => void;
    handleOnClick: (isAndroidApp: boolean) => void;
    handleOnError: (e: google.payments.api.PaymentsError | Error) => void;
    handleOnLoadPaymentData: (
        paymentData: google.payments.api.PaymentData,
        instance: GooglePayment,
    ) => void;
    instance: GooglePayment;
    isAndroidApp: boolean;
    paymentRequest?: google.payments.api.PaymentDataRequest;
}

export const GooglePayButton: React.FunctionComponent<GooglePayButtonProps> = ({
    clearError,
    defaultLocale,
    environment,
    handleOnCancel,
    handleOnClick,
    handleOnError,
    handleOnLoadPaymentData,
    instance,
    isAndroidApp,
    paymentRequest,
}) => {
    useEffect(() => {
        if (isAndroidApp) {
            const googlePayButtonInAndroidApp =
                new google.payments.api.PaymentsClient({
                    environment,
                }).createButton({
                    buttonColor: 'default',
                    buttonType: 'buy',
                    // buttonLocale: { defaultLocale },
                    onClick: () => handleOnClick(true),
                });

            const buttonContainer = document.getElementById(
                'google-pay-button-wrapper',
            );

            googlePayButtonInAndroidApp.classList.add('google-pay-button');

            buttonContainer?.children?.[0]?.replaceWith(
                googlePayButtonInAndroidApp,
            );
        }

        return () => clearError();
    }, [clearError, environment, handleOnClick, isAndroidApp]);

    const placeholderButton = (
        <div className="placeholder-button-wrapper">
            <Button
                data-testid="google-pay-button-placeholder"
                disabled={true}
                isLoading={true}
                size={SIZE_BLOCK}
                style={STYLE_FILL}
            >
                {gettext('Place Order')}
            </Button>
        </div>
    );

    const googlePayButtonInWebApp =
        paymentRequest && !isAndroidApp ? (
            <ButtonFromGoogle
                buttonLocale={defaultLocale}
                buttonType="buy"
                className="google-pay-button"
                environment={environment}
                onCancel={handleOnCancel}
                onClick={() => handleOnClick(false)}
                onError={(e) => {
                    handleOnError(e);
                }}
                onLoadPaymentData={(paymentData) => {
                    handleOnLoadPaymentData(paymentData, instance);
                }}
                paymentRequest={paymentRequest}
            />
        ) : (
            placeholderButton
        );

    return (
        <div
            className="google-pay-button-wrapper"
            id="google-pay-button-wrapper"
        >
            {googlePayButtonInWebApp}
        </div>
    );
};
